import { Checkbox, withStyles } from "@material-ui/core";
import { CheckboxProps } from "@material-ui/core/Checkbox";
import { grey, yellow } from "@material-ui/core/colors";
import StarIcon from "@material-ui/icons/Star";
import Form from "@saleor/components/Form";
import { SubmitPromise } from "@saleor/hooks/useForm";
import React from "react";

const FeatureCheckbox = withStyles(
  {
    checked: {},
    root: {
      "&$checked": {
        color: yellow[600]
      },
      color: grey[400]
    }
  },
  { name: "FeaturedCheckbox" }
)((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export interface FeaturedInitialFormData {
  id: string;
  isFeatured: boolean;
}

export interface CouponFeaturedStarProps {
  id: string;
  isFeatured: boolean;
  onSubmit?: (data: FeaturedInitialFormData) => SubmitPromise;
}

const CouponFeaturedStar: React.SFC<CouponFeaturedStarProps> = props => {
  const { id, isFeatured, onSubmit } = props;

  const featuredInitialForm: FeaturedInitialFormData = {
    id,
    isFeatured
  };

  const handleOnSubmit = e => {
    onSubmit(e);
  };
  return (
    <Form initial={featuredInitialForm} onSubmit={handleOnSubmit}>
      {({ data, change, submit }) => (
        <>
          <FeatureCheckbox
            id="isFeaturedCheckbox"
            icon={<StarIcon />}
            checkedIcon={<StarIcon />}
            disabled={false}
            checked={data.isFeatured}
            onChange={e => {
              change(e);
              submit();
            }}
            name="isFeatured"
            inputProps={{ "aria-label": "controlled" }}
          />
        </>
      )}
    </Form>
  );
};
CouponFeaturedStar.displayName = "CouponFeaturedStar";
export default CouponFeaturedStar;
